import { Toast } from "react-hot-toast/headless";
import toast from "react-hot-toast/headless";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheck,
  faCircleXmark,
  faLoader,
  faTimes,
  IconDefinition
} from "@fortawesome/pro-solid-svg-icons";
import { Button } from "../../../../ui/components/Button";
import { t } from "i18next";
import classNames from "classnames";

export const Notification = ({ariaProps, id, message, type}: Toast) => {
  let icon: IconDefinition | undefined = undefined;
  let iconStyle = "";
  let notificationStyle = "bg-white border-gray-400";
  switch (type) {
  case "blank":
  case "custom":
    break;
  case "error":
    icon = faCircleXmark;
    iconStyle = "text-red-500";
    notificationStyle = "bg-red-100 border-red-400";
    break;
  case "loading":
    icon = faLoader;
    iconStyle = "text-blue-500";
    notificationStyle = "bg-blue-100 border-blue-400";
    break;
  case "success":
    icon = faCheck;
    iconStyle = "text-green-500";
    notificationStyle = "bg-green-100 border-green-400";
    break;
  }

  return (
    <div className={classNames(notificationStyle, "border flex items-center space-x-2 px-4 py-2 max-w-md")} {...ariaProps}>
      {
        !!icon &&
        <FontAwesomeIcon className={classNames(iconStyle, "text-xl")}
          icon={icon}/>
      }
      <div className="break-words max-w-[16rem] lg:max-w-xs px-2">
        {message}
      </div>
      {type !== "loading" && (
        <Button className="pointer-events-auto text-gray-500" variant="none"
          title={t`Close`} onClick={() => toast.dismiss(id)}>
          {/*Name specified so it can be identified when bypassing headlessui component restrictions*/}
          <FontAwesomeIcon icon={faTimes} name="toast-notification-close"/>
        </Button>
      )}
    </div>
  );
};
